<template>
  <div class="fertilizer">
    <div class="box">
      <a href="http://www.dnscoop.com/">
        <img
          src="./price.png"
          width="533"
          height="392"
          alt="Prislapp som sier $67"
          title="Prislapp"
          border="0"
        >
      </a>
    </div>
    <div class="updated">16 IV 2007</div>
  </div>
</template>

<script>
export default {
  name: "price"
};
</script>

<style scoped>
.fertilizer {
  background-image: linear-gradient(#660099, #000033);
}

.box {
  margin-top: -196px;
}

.updated {
  color: #ccc;
}
</style>
